/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/itemgrideditor.ts" />

namespace TabAurous.ProductDevelopment {

    import fld = RequirementStoneItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class RequirementStoneItemsEditor extends _Ext.GridEditorBase<RequirementStoneItemsRow> {
        protected getColumnsKey() { return "ProductDevelopment.RequirementStoneItems"; }
        protected getDialogType() { return RequirementStoneItemsDialog; }
        protected getLocalTextPrefix() { return RequirementStoneItemsRow.localTextPrefix; }

        protected form: RequirementStoneItemsForm;


        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = true;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public MarkUpPolicyId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number;
        isEditable: boolean;

        // #endregion

        // #region Constructor
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, rowHeight: 30 });
            this.toolbar.findButton('add-button').find('.button-inner').text('New Product');

            this.isEditable = this.slickGrid.getOptions().editable;

        }
        // #endregion

        protected getColumns() {

            var columns = super.getColumns();

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }


        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        // #endregion

        //#region  ItemGrid Inline Editor

        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && !item.HasBom) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var rate = item.UnitRate || 0;
                    if (item.ItemTypeId == 101 || item.ItemTypeId == 104) {
                        rate = item.UnitRate * item.Purity;
                        item.PureWeight = value * item.Purity;
                    }

                    var Net = (rate + labr) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }
                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;
            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;
            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;
            }

            item.UnitCost = item.CalcOnId == 3 ? (item.UnitRate + item.UnitLabour) / item.Pieces : (item.UnitRate + item.UnitLabour) / item.Weight;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;
            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;

            this.view.updateItem(id, item);

            this.view.refresh();
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }
        validateEntity(row: RequirementStoneItemsRow, id) {
            row.ProductTypeName = OMS.ProductTypeRow.getLookup().itemById[row.ProductTypeId].ProductTypeCode;
            var quality = OMS.AttributeMasterRow.getLookup().itemById[row.QualityId];
            row.QualityName = quality.AttributeName;
            row.QualityCode = quality.AttributeCode;
            var shape = OMS.AttributeMasterRow.getLookup().itemById[row.ShapeId];
            row.ShapeName = shape.AttributeName;
            row.ShapeCode = shape.AttributeCode;
            var stone = OMS.AttributeMasterRow.getLookup().itemById[row.StoneColorId];
            row.StoneColoreName = stone.AttributeName;
            row.StoneColorCode = stone.AttributeCode;

            var size = OMS.AttributeMasterRow.getLookup().itemById[row.StoneSizeId];
            row.StoneSizeName = size.AttributeCode;
            return true;
        }
        // #endregion

        getButtons() {
            var buttons = super.getButtons();
            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            var onclick = addbutton.onClick;

            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: "Add Stone",
                onClick: onclick

            })
            return buttons;
        }
        public setData(bomvalues:any[]) {

            this.view.setItems([], false);
            var tmp = [];
            for (let bom of bomvalues) {
                bom[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(bom);
            }
            return tmp;

        }
    }
}